module.exports = __webpack_public_path__ + "img/md5-normal4.b9ad2f31.png";